var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('sidebar-fixed-toggle-button'),_c('side-bar',{attrs:{"background-color":_vm.backgroundColor}},[_c('template',{slot:"links"},[_c('sidebar-link',{attrs:{"link":{
          name: _vm.$t('sidebar.dashboard'),
          icon: 'tim-icons icon-chart-pie-36',
          path: '/dashboard',
        }}}),_c('sidebar-link',{attrs:{"link":{
          name: 'Comparador',
          icon: 'tim-icons icon-single-02',
          path: '/clientes',
        }}}),_c('sidebar-link',{attrs:{"link":{
          name: 'Calendário',
          icon: 'tim-icons icon-calendar-60',
          path: '/calendar',
        }}}),_c('sidebar-link',{attrs:{"link":{
          name: 'Notificações',
          icon: 'tim-icons icon-bell-55',
          path: '/notificacoes',
        }}}),(_vm.admin)?_c('sidebar-link',{attrs:{"link":{
          name: 'Upload Excel',
          icon: 'tim-icons icon-upload',
          path: '/upload',
        }}}):_vm._e()],1)],2),_c('sidebar-share',{attrs:{"background-color":_vm.backgroundColor},on:{"update:backgroundColor":function($event){_vm.backgroundColor=$event},"update:background-color":function($event){_vm.backgroundColor=$event}}}),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.backgroundColor}},[_c('top-navbar'),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar.apply(null, arguments)}}}),_c('content-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }